module.exports = __webpack_public_path__ + "img/sb01-03.12407940.png";